<lhpe-audience-list [fromCustomer]="true"></lhpe-audience-list>
